import { createReducer } from '@reduxjs/toolkit';

import * as buttonActions from './buttonActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'button',
  isActive: false,

  textAlign: 'left',
  backgroundColor: '#000000',
  textColor: '#ffffff',
  borderRadius: 0,
  shape: 'square',
  text: '',
  url: '',
  isFullWidth: false,
};

const button = createReducer(initialState, (builder) => {
  builder
    .addCase(buttonActions.buttonUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(buttonActions.buttonUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(buttonActions.buttonStore, (state, { payload: data }) => {
      const {
        blockId,
        uid,
        isActive,

        button,
      } = data;

      const section = button ?? {};
      const { aligment, backgroundColor, textColor, borderRadius, shape, text, url, isFullWidth } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: blockId ?? 0,
        uid: uid ?? 0,
        isAdded: isActive,

        textAlign: aligment ?? 'left',
        backgroundColor: backgroundColor ?? '#000000',
        textColor: textColor ?? '#ffffff',
        borderRadius: borderRadius ?? 0,
        shape: shape ?? 'square',
        text: text ?? '',
        url: url ?? '',
        isFullWidth: isFullWidth ?? false,
      };
    })
    .addCase(buttonActions.buttonClear, () => ({ ...initialState }))

    .addCase(buttonActions.buttonUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(buttonActions.buttonUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(buttonActions.buttonUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(buttonActions.buttonUpdateTextAlign, (state, { payload: textAlign }) => ({ ...state, textAlign }))
    .addCase(buttonActions.buttonUpdateBackgroundColor, (state, { payload: backgroundColor }) => ({ ...state, backgroundColor }))
    .addCase(buttonActions.buttonUpdateTextColor, (state, { payload: textColor }) => ({ ...state, textColor }))
    .addCase(buttonActions.buttonUpdateBorderRadius, (state, { payload: borderRadius }) => ({ ...state, borderRadius }))
    .addCase(buttonActions.buttonUpdateShape, (state, { payload: shape }) => ({ ...state, shape }))
    .addCase(buttonActions.buttonUpdateIsFullWidth, (state, { payload: isFullWidth }) => ({ ...state, isFullWidth }))
    .addCase(buttonActions.buttonUpdateText, (state, { payload: text }) => ({ ...state, text }))
    .addCase(buttonActions.buttonUpdateUrl, (state, { payload: url }) => ({ ...state, url }));
});

export default button;
